import Cigar from "../assets/images/west-coast-icons/cigar.png";
import CStore from "../assets/images/west-coast-icons/c-store.png";
import Flowers from "../assets/images/west-coast-icons/flowers.png";
import Glasses from "../assets/images/west-coast-icons/glasses.png";
import Hookah from "../assets/images/west-coast-icons/hookah.png";
import SmokeVape from "../assets/images/west-coast-icons/vape.png";
import Ashtray from "../assets/images/west-coast-icons/ashtray.png";
import GasMask from "../assets/images/west-coast-icons/gas-mask.png";

const categories = [
  {
    id: 1,
    image: Cigar,
    class: "bg-primaryRed bg-opacity-5",
    label: "Cigar",
  },
  {
    id: 2,
    image: CStore,
    class: "bg-primaryRed bg-opacity-5",
    label: "C-store",
  },
  {
    id: 3,
    image: Flowers,
    class: "bg-primaryRed bg-opacity-5",
    label: "Flower / Wax",
  },
  {
    id: 4,
    image: Glasses,
    class: "bg-primaryRed bg-opacity-5",
    label: "Glass",
  },
  {
    id: 5,
    image: Hookah,
    class: "bg-primaryRed bg-opacity-5",
    label: "Hookah",
  },
  {
    id: 6,
    image: SmokeVape,
    class: "bg-primaryRed bg-opacity-5",
    label: "Smoke & Vape",
  },
  {
    id: 8,
    image: Ashtray,
    class: "bg-primaryRed bg-opacity-5",
    label: "Ashtrays",
  },
  {
    id: 9,
    image: GasMask,
    class: "bg-primaryRed bg-opacity-5",
    label: "Gas Masks",
  },
];

export default categories;
